'use strict';

var React = require('react');
var createReactClass = require('create-react-class');
var ReactDOM = require('react-dom');
var LocalizeMixin = require("../../localization/CommonLocalizationMixin");
var FloatLabelField = require('../FloatLabelField.js');

var ResetPasswordForm = createReactClass({
    displayName: 'ResetPasswordForm',
    mixins: [LocalizeMixin],

    getInitialState: function getInitialState() {
        return {
            validationObj: {
                confirmedPassword: false,
                password: false
            }
        };
    },

    getForm: function getForm() {
        return {
            password: ReactDOM.findDOMNode(this.refs.password).children[0].value
        };
    },

    onSubmit: function onSubmit(e) {
        e.preventDefault();

        var form = this.getForm();

        var error = false;
        for (var prop in form) {
            if (!form[prop] && prop != 'optIn') {
                error = true;
            }
        }
        if (!error) {
            if (this.props.handleResetPassword) {
                this.props.handleResetPassword(form);
            }
        } else {
            alert('All fields are required.');
        }
    },

    checkFormValidity: function checkFormValidity() {
        var validationObj = this.state.validationObj;
        var disable = false;

        for (var prop in validationObj) {
            if (!validationObj[prop] || validationObj[prop] != true) {
                disable = true;
            }
        }

        return !disable;
    },

    render: function render() {
        var _this = this;

        var welcomeMessage = this.getLocalizedText('common_login_reset_message') + ' ' + (this.props.email || '');
        var passwordRequirements = this.props.passwordRequirements || '';

        var formValidity = this.checkFormValidity();
        var disableSubmitButton = formValidity ? 'btn btn-primary col-xs-12 submit-button' : 'btn btn-primary col-xs-12 submit-button disable-submit';
        return React.createElement(
            'div',
            { className: 'login-box clearfix' },
            React.createElement(
                'div',
                { className: 'welcome-message' },
                welcomeMessage
            ),
            React.createElement(
                'form',
                { onSubmit: this.onSubmit },
                React.createElement(FloatLabelField, { required: true, type: 'password', id: 'password-input', onChangeHandler: function onChangeHandler(value, recursiveCheck) {
                        return _this.validatePassword(value, recursiveCheck);
                    },
                    placeHolder: this.getLocalizedText("email_sign_up_password"),
                    ref: 'password' }),
                React.createElement(FloatLabelField, { required: true, type: 'password', id: 'confirm-password-input', onChangeHandler: function onChangeHandler(value, recursiveCheck) {
                        return _this.validateConfirmedPassword(value, recursiveCheck);
                    },
                    placeHolder: this.getLocalizedText("email_sign_up_confirm_password"),
                    ref: 'confirmedPassword' }),
                React.createElement(
                    'div',
                    { className: 'col-xs-12 field-description' },
                    React.createElement(
                        'div',
                        null,
                        passwordRequirements
                    )
                ),
                React.createElement(
                    'button',
                    { type: 'submit', className: disableSubmitButton, disabled: !formValidity, id: 'login-btn' },
                    this.getLocalizedText('common_login_reset')
                )
            )
        );
    },

    checkAndUpdateValidationObjectIfNeeded: function checkAndUpdateValidationObjectIfNeeded(validationObjProp, value) {
        if (this.state.validationObj[validationObjProp] != value) {
            var validationObj = _.cloneDeep(this.state.validationObj);
            validationObj[validationObjProp] = value;
            this.setState({ validationObj: validationObj });
        }
    },

    validatePassword: function validatePassword(input, recursiveCheck) {
        var password = ReactDOM.findDOMNode(this.refs.confirmedPassword).children[0].value;
        var retValue = "";

        if (!input || input.replace(/\s/g, "") == "") {
            this.checkAndUpdateValidationObjectIfNeeded('password', false);
            retValue = 'Required';
        } else if (password && input && input != password) {
            this.checkAndUpdateValidationObjectIfNeeded('password', false);
            retValue = 'Does Not Match';
        } else {
            this.checkAndUpdateValidationObjectIfNeeded('password', true);
            if (!recursiveCheck) {
                this.refs.confirmedPassword.isPopulated({ currentTarget: { value: password } }, true);
            }
        }

        return retValue;
    },

    validateConfirmedPassword: function validateConfirmedPassword(input, recursiveCheck) {
        var password = ReactDOM.findDOMNode(this.refs.password).children[0].value;
        var retValue = "";

        if (!input || input.replace(/\s/g, "") == "") {
            this.checkAndUpdateValidationObjectIfNeeded('confirmedPassword', false);
            retValue = 'Required';
        } else if (password && input && input != password) {
            this.checkAndUpdateValidationObjectIfNeeded('confirmedPassword', false);
            retValue = 'Does Not Match';
        } else {
            this.checkAndUpdateValidationObjectIfNeeded('confirmedPassword', true);
            if (!recursiveCheck) {
                this.refs.password.isPopulated({ currentTarget: { value: password } }, true);
            }
        }

        return retValue;
    }
});

module.exports = ResetPasswordForm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/ResetPasswordForm.js
// module id = 603
// module chunks = 0